import { DefaultElectrsAPI } from "./external/electrs";
import { DefaultNominationAPI } from "./parachain/nomination";
import { DefaultIssueAPI } from "./parachain/issue";
import { DefaultOracleAPI } from "./parachain/oracle";
import { DefaultRedeemAPI } from "./parachain/redeem";
import { DefaultFeeAPI } from "./parachain/fee";
import { DefaultVaultsAPI } from "./parachain/vaults";
import { DefaultSystemAPI } from "./parachain/system";
import { DefaultTokensAPI } from "./parachain/tokens";
import { FaucetClient } from "./clients";
import { DefaultBTCRelayAPI } from "./parachain/btc-relay";
import { DefaultReplaceAPI } from "./parachain/replace";
import { networks } from "bitcoinjs-lib";
import { DefaultRewardsAPI } from "./parachain/rewards";
import { DefaultTransactionAPI } from "./parachain/transaction";
import { DefaultAssetRegistryAPI, DefaultEscrowAPI, DefaultLoansAPI } from ".";
import { tokenSymbolToCurrency } from "./utils";
import { DefaultAMMAPI } from "./parachain/amm";
export * from "./factory";
export * from "./parachain/transaction";
export function getBitcoinNetwork(network = "mainnet") {
    switch (network) {
        case "mainnet":
            return networks.bitcoin;
        case "testnet":
            return networks.testnet;
        default:
            return networks.regtest;
    }
}
/**
 * @category BTC Bridge
 */
export class DefaultInterBtcApi {
    constructor(api, bitcoinNetwork = "mainnet", _account, esploraNetwork) {
        this.api = api;
        const wrappedCurrency = this.getWrappedCurrency();
        const governanceCurrency = this.getGovernanceCurrency();
        const btcNetwork = getBitcoinNetwork(bitcoinNetwork);
        this.electrsAPI = new DefaultElectrsAPI(esploraNetwork || bitcoinNetwork);
        this.transaction = new DefaultTransactionAPI(api, _account);
        this.assetRegistry = new DefaultAssetRegistryAPI(api);
        this.oracle = new DefaultOracleAPI(api, wrappedCurrency);
        this.loans = new DefaultLoansAPI(api, wrappedCurrency, this.oracle);
        this.tokens = new DefaultTokensAPI(api);
        this.system = new DefaultSystemAPI(api);
        this.fee = new DefaultFeeAPI(api, this.oracle);
        this.rewards = new DefaultRewardsAPI(api, wrappedCurrency);
        this.escrow = new DefaultEscrowAPI(api, governanceCurrency, this.system);
        this.vaults = new DefaultVaultsAPI(api, this.electrsAPI, wrappedCurrency, governanceCurrency, this.tokens, this.oracle, this.fee, this.rewards, this.system, this.transaction);
        this.faucet = new FaucetClient(api, "");
        this.btcRelay = new DefaultBTCRelayAPI(api);
        this.replace = new DefaultReplaceAPI(api, btcNetwork, this.electrsAPI, wrappedCurrency);
        this.issue = new DefaultIssueAPI(api, btcNetwork, this.electrsAPI, wrappedCurrency, this.vaults, this.transaction);
        this.redeem = new DefaultRedeemAPI(api, btcNetwork, this.electrsAPI, wrappedCurrency, this.vaults, this.oracle, this.transaction, this.system);
        this.nomination = new DefaultNominationAPI(api, wrappedCurrency, this.vaults, this.rewards);
        this.amm = new DefaultAMMAPI(api, this.tokens);
    }
    setAccount(account, signer) {
        if (!account.sign && !signer) {
            throw new Error("signer must be passed if account is not a Keypair");
        }
        if (signer) {
            this.api.setSigner(signer);
        }
        this.transaction.setAccount(account);
    }
    removeAccount() {
        this.transaction.removeAccount();
    }
    get account() {
        return this.transaction.getAccount();
    }
    getGovernanceCurrency() {
        const currencyId = this.api.consts.currency.getNativeCurrencyId;
        // beware: this call will throw if the native currency is not a token!
        return tokenSymbolToCurrency(currencyId.asToken);
    }
    getWrappedCurrency() {
        const currencyId = this.api.consts.currency.getWrappedCurrencyId;
        // beware: this call will throw if the wrapped currency is not a token!
        return tokenSymbolToCurrency(currencyId.asToken);
    }
    getRelayChainCurrency() {
        const currencyId = this.api.consts.currency.getRelayChainCurrencyId;
        // beware: this call will throw if the currency is not a token!
        return tokenSymbolToCurrency(currencyId.asToken);
    }
    disconnect() {
        return this.api.disconnect();
    }
}
//# sourceMappingURL=interbtc-api.js.map